'use strict';

module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/faye/src/util/cookies/browser_cookies.js
// module id = 40
// module chunks = 0